module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('list', {
    attrs: {
      "listTitle": "Anúncios",
      "listLogo": _vm.module.logo,
      "filterTitle": "Filtros",
      "loading": _vm.loading,
      "total": _vm.productsMarketplaceTotal,
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'desc'
      }
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Código do produto"
    }
  }, [_c('vue-tags-input', {
    staticClass: "form-input",
    attrs: {
      "tags": _vm.productCodes,
      "separators": [','],
      "add-on-key": [','],
      "placeholder": ""
    },
    on: {
      "tags-changed": function (newCodes) { return _vm.productCodes = newCodes; }
    },
    model: {
      value: (_vm.options.code),
      callback: function($$v) {
        _vm.$set(_vm.options, "code", $$v)
      },
      expression: "options.code"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplos códigos.")])], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "EAN do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.ean),
      expression: "options.ean"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.ean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "ean", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Título do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.title),
      expression: "options.title"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status do produto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.productStatuses), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$te(((_vm.moduleDI.identifier) + ".status." + status + ".label")) ? _vm.$t(((_vm.moduleDI.identifier) + ".status." + status + ".label")) : _vm.$t((status + ".label"))) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status do preço do produto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.priceStatus),
      expression: "options.priceStatus"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "priceStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.productPriceStatuses), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t((status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status do estoque do produto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.stockStatus),
      expression: "options.stockStatus"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "stockStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.productStockStatuses), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t((status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Conta"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.account),
      expression: "options.account"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.productAccounts), function(account) {
    return _c('option', {
      key: account,
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v(_vm._s(account.nickname))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tipo de preço"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.priceType),
      expression: "options.priceType"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "priceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.productPriceTypes), function(priceType) {
    return _c('option', {
      key: priceType,
      domProps: {
        "value": priceType
      }
    }, [_vm._v(_vm._s(_vm.$t((priceType + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t("saleAvailability.label")
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.saleAvailability),
      expression: "options.saleAvailability"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "saleAvailability", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.productSaleAvailabilities), function(saleAvailability) {
    return _c('option', {
      key: saleAvailability,
      domProps: {
        "value": saleAvailability
      }
    }, [_vm._v(_vm._s(_vm.$t(("saleAvailability." + saleAvailability + ".label"))) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tipo checkout"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.typeCheckout),
      expression: "options.typeCheckout"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "typeCheckout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Frete grátis"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.shippingFree),
      expression: "options.shippingFree"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "shippingFree", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('productGroupedId.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.productId),
      expression: "options.productId"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.productId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "productId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._t("custom-filters")], 2), _vm._v(" "), _vm._l((_vm.productsMarketplaceItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-12@md"
    }, [_c('announcement-card', {
      ref: "items",
      refInFor: true,
      attrs: {
        "product": item,
        "module": _vm.moduleDI
      }
    })], 1)
  }), _vm._v(" "), (!_vm.productsMarketplaceItems.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhum produto encontrado.\n      ")])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edd6623a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAnnouncement/List.vue
// module id = 3482
// module chunks = 0